module.exports = "<router-outlet>\r\n</router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/blank-layout/blank-layout.component.html
// module id = ./src/app/containers/blank-layout/blank-layout.component.html
// module chunks = main